// Salaries upload: Finance gives the month's sheet; it is checked against the approved payees (nothing is created yet),
// then one salary request per person is created for the usual approval.
import { useState } from "react";
import { Page, Card, Btn, Table, Tr, Td, Field, TextIn, Pill, money } from "@/components/kit";
import api from "@/lib/api";
import { act, Select, DateIn } from "@/components/erp";
import { today } from "@/lib/money";
import { download } from "@/lib/download";

export default function Salaries() {
  const [file, setFile] = useState(null);
  const [f, setF] = useState({ category: "salaries", date: today(), description: "" });
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const send = async (commit) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("category", f.category);
    fd.append("date", f.date);
    fd.append("description", f.description);
    fd.append("commit", commit ? "true" : "false");
    setBusy(true);
    const d = await act(() => api.post("/costs/salary-import", fd), commit ? (x) => `${x.ok} salary requests created - they go for approval` : null);
    setBusy(false);
    if (d) setRes(d);
  };
  return (
    <Page title="Salaries upload">
      <Card className="max-w-3xl bg-white">
        <p className="text-sm text-slate-600">Upload the month's salary sheet (Excel or CSV). The first row has headings: <b>Name</b>, <b>Phone</b> and/or <b>ID</b>, and <b>Amount</b>.
          Each person must already be an approved payee. You see the check first; nothing is created until you confirm. Each person becomes one request, approved like any salary, and then goes into the bulk file.</p>
        <div className="mt-3 grid gap-3 sm:grid-cols-3">
          <Field label="Which salaries"><Select empty={null} value={f.category} onChange={(v) => setF({ ...f, category: v })}
            options={[{ value: "salaries", label: "Drivers' salaries" }, { value: "garage_salaries", label: "Garage salaries" }]} /></Field>
          <Field label="Pay date"><DateIn value={f.date} onChange={(v) => setF({ ...f, date: v })} /></Field>
          <Field label="Details (e.g. November salary)"><TextIn value={f.description} onChange={(v) => setF({ ...f, description: v })} /></Field>
        </div>
        <div className="mt-3"><Btn onClick={() => download("/costs/salary-template")}>Download the template</Btn></div>
        <div className="mt-3"><input type="file" accept=".xlsx,.xlsm,.csv" onChange={(e) => { setFile(e.target.files?.[0] || null); setRes(null); }} /></div>
        <div className="mt-3"><Btn kind="primary" disabled={!file || busy} onClick={() => send(false)}>Check the sheet</Btn></div>
      </Card>
      {res && (
        <>
          <p className="mt-4 text-sm"><b>{res.ok}</b> ready · total <b>{money(res.total)}</b> · {res.category} · "{res.description}"
            {res.problems > 0 && <span className="text-red-600"> · {res.problems} need attention</span>}</p>
          {!res.committed && res.ok > 0 && <div className="mt-2"><Btn kind="primary" disabled={busy} onClick={() => send(true)}>Create {res.ok} salary requests ({money(res.total)})</Btn></div>}
          <Table minWidth={760} cols={[{ label: "Row" }, { label: "On the sheet" }, { label: "Payee" }, { label: "Amount", align: "right" }, { label: "" }]}>
            {res.rows.map((r) => (
              <Tr key={r.row}><Td>{r.row}</Td><Td>{r.name} {r.phone} {r.id_no}</Td><Td>{r.payee || "—"}</Td><Td right>{money(r.amount)}</Td>
                <Td>{r.problem ? <Pill kind="red">{r.problem}</Pill> : r.created ? <Pill kind="green">requested</Pill> : <Pill kind="green">ready</Pill>}</Td></Tr>))}
          </Table>
        </>)}
    </Page>
  );
}
